import ModalsUtil from '../../../utils/modals';
import Slider from 'react-slick';
import {useRef} from 'react';
import ImageUtil from '../../../utils/image';

export default () => {
    const slider = useRef();

    return (
        <div className="modal modal-events animate__zoomIn animate__animated" data-target="events" style={{display: 'none'}}>
            <div className="modal-close" onClick={e => ModalsUtil.close()}></div>
            <div className="title">
                EVENTS
            </div>
            <div className="content">
                <div className="arrows">
                    <div className="arrow left" onClick={() => slider?.current?.slickPrev()}></div>
                    <div className="arrow right" onClick={() => slider?.current?.slickNext()}></div>
                </div>
                <div className="slider">
                    <Slider
                        ref={slider}
                        dots={false}
                        infinite={true}
                        slidesToShow={1}
                        slidesToScroll={1}
                        arrows={false}>
                            <div>
                                <div className="slide">
                                    <ImageUtil path="/images/modals/events/slide.png" alt="Slide" />
                                </div>
                            </div>
                            <div>
                                <div className="slide">
                                    <ImageUtil path="/images/modals/events/slide.png" alt="Slide" />
                                </div>
                            </div>
                            <div>
                                <div className="slide">
                                    <ImageUtil path="/images/modals/events/slide.png" alt="Slide" />
                                </div>
                            </div>
                            <div>
                                <div className="slide">
                                    <ImageUtil path="/images/modals/events/slide.png" alt="Slide" />
                                </div>
                            </div>
                            <div>
                                <div className="slide">
                                    <ImageUtil path="/images/modals/events/slide.png" alt="Slide" />
                                </div>
                            </div>
                    </Slider>
                </div>
            </div>
        </div>
    )
}